import { render } from "./6.vue?vue&type=template&id=9c936c64"
import script from "./6.vue?vue&type=script&lang=js"
export * from "./6.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__